var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    className: "me-2",
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2489_11118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5179 20H14.4889C14.3991 20 5.41221 19.9829 3.14484 19.3763C2.5322 19.2136 1.97366 18.8954 1.52514 18.4532C1.07662 18.0111 0.753854 17.4606 0.589158 16.857C0.181442 14.5909 -0.0154461 12.2928 0.000944902 9.99144C-0.00958112 7.68629 0.192635 5.38497 0.605095 3.1159C0.774445 2.51124 1.0987 1.95961 1.54674 1.51395C1.99479 1.06829 2.55158 0.743567 3.16368 0.570939C5.36875 1.27615e-07 14.1079 0 14.4788 0H14.5092C14.6005 0 23.6106 0.0171279 25.8548 0.623751C27.0993 0.956323 28.0714 1.91407 28.4076 3.14017C28.8277 5.41536 29.0262 7.72338 28.9972 10.0357C29.0074 12.338 28.8047 14.6365 28.3916 16.9027C28.2248 17.5057 27.9007 18.0552 27.4516 18.4966C27.0025 18.938 26.444 19.2561 25.8316 19.4191C23.6294 19.9943 14.8888 20 14.5179 20ZM11.6203 5.71653L11.6131 14.2806L19.1642 9.99857L11.6203 5.71653Z",
    fill: "url(#paint0_linear_2489_11118)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2489_11118",
    x: 0,
    y: 0,
    width: 29,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_11118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2489_11118",
    x1: 17.5,
    y1: -11.5,
    x2: 14.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA2BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE4C55"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon18);
export default __webpack_public_path__ + "static/media/icon18.8cd332a46daadd341261bcbe4cd7658a.svg";
export { ForwardRef as ReactComponent };